import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { User, ShieldCheck, Loader2 } from "lucide-react";
import Logo from "../components/Logo";
import { useAuth } from "../context/AuthContext";
import { api, errMsg } from "../lib/api";
import { ROLE_HOME } from "../lib/format";
import { PageLoader } from "../components/ProtectedRoute";

const ROLES = [
  { role: "pengguna", title: "Saya Pengguna", desc: "Ingin mencari & memesan jasa inspeksi kendaraan sebelum membeli.", icon: User, color: "bg-blue-50 text-blue-600" },
  { role: "inspector", title: "Saya Inspector", desc: "Teknisi profesional yang ingin menawarkan jasa inspeksi dan menerima pesanan.", icon: ShieldCheck, color: "bg-emerald-50 text-emerald-600" },
];

export default function SelectRolePage() {
  const { user, loading, setUser } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState("");
  if (loading) return <PageLoader />;
  if (!user) return <Navigate to="/masuk" replace />;
  if (user.role) return <Navigate to={ROLE_HOME[user.role]} replace />;

  const choose = async (role) => {
    setBusy(role);
    try {
      const { data } = await api.post("/auth/select-role", { role });
      setUser(data);
      toast.success(role === "inspector" ? "Selamat datang! Lengkapi profil untuk verifikasi." : "Selamat datang di Inspecar!");
      navigate(role === "inspector" ? "/inspector/profil" : ROLE_HOME[role], { replace: true });
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(""); }
  };

  return (
    <div className="min-h-screen bg-[#f7f9fc] font-sans flex flex-col items-center px-4 py-10">
      <Logo />
      <div className="mt-10 max-w-2xl w-full text-center">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight">Halo, {user.name.split(" ")[0]}! Pilih peran Anda</h1>
        <p className="text-slate-500 text-sm mt-2">Peran menentukan dashboard dan fitur yang Anda gunakan. Pilihan ini tidak dapat diubah sendiri.</p>
        <div className="grid sm:grid-cols-2 gap-5 mt-10 text-left">
          {ROLES.map((r) => (
            <button key={r.role} onClick={() => choose(r.role)} disabled={!!busy} data-testid={`select-role-${r.role}`}
              className="bg-white rounded-2xl border-2 border-slate-100 hover:border-blue-500 p-7 transition-colors group disabled:opacity-60">
              <span className={`inline-flex p-3.5 rounded-2xl ${r.color}`}><r.icon size={26} /></span>
              <p className="text-lg font-extrabold text-slate-900 mt-4">{r.title}</p>
              <p className="text-sm text-slate-500 mt-1.5 leading-relaxed">{r.desc}</p>
              <span className="inline-flex items-center gap-2 mt-5 text-sm font-bold text-blue-600">
                {busy === r.role ? <Loader2 size={16} className="animate-spin" /> : null} Pilih peran ini →
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
